/* eslint-disable */

export interface inputInterface {
  name: string
  lastName: string
  email: string
  company: string
  roleCompany: string
  location: string
}
interface ValidationErrors {
  [key: string]: string;
}

const validateNewUser = (input: inputInterface): ValidationErrors => {
  const errors: ValidationErrors = {};
  !input.email && (errors.email = 'Email is required');
  !input.lastName && (errors.lastName = 'Last name is required');
  !input.name && (errors.name = 'Name is required');
  !input.roleCompany && (errors.roleCompany = 'Company position is required');
  !input.company && (errors.company = 'Company is required');
  !input.location && (errors.location = 'Location is required');
  return errors;
};

const validateExistingUser = (input: inputInterface): ValidationErrors => {
  const errors: ValidationErrors = {};
  if (!input.name) {
    errors.name = 'Name is required';
  } else if (input.name && !/^[A-Za-z\s]+$/g.test(input.name)) {
    errors.name = 'Name is invalid';
  }
  if (!input.lastName) {
    errors.lastName = 'Last name is required';
  }
  
  if (!input.roleCompany) {
    errors.roleCompany = 'Role Company position is required';
  }
  
  if (!input.location) {
    errors.location = 'Location is required';
  }
  if (input.lastName) {
    if (!/^[A-Za-z\s]+$/g.test(input.lastName)) {
      errors.lastName = 'Last name is invalid';
    }
  }

  if(!input.email){
    errors.email = 'Email is required';
  } else if (input.email) {
    if (
      !/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/.test(
        input.email
      )
    ) {
      errors.email = 'Email is invalid';
    }
  }

  if(!input.company){
    errors.company = 'Company is required';
  }
  return errors;
};


const validate = (input: inputInterface): ValidationErrors => {
  return validateExistingUser(input);//input.email ? validateExistingUser(input) : validateNewUser(input);
};


export default validate
